import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Spinner, Row, Col } from "react-bootstrap";
import useReactRouter from "use-react-router";
import NumberFormat from "react-number-format";
import axios from "axios";
import { COLOR_APP, CREATED, LOGISTICS, SHOP_DATA } from "../../../constants";
import _ from "lodash";
import { GET_STOCKS } from "../../../graphql/stock/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { imageRender, thousandSeperate } from "../../../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { GET_ORDERGROUPS_DETAIL } from "../../../graphql/order/query";
import { CREATE_ORDER_GROUP_FROM_MESSAGE } from "../../../graphql/order/mutation";
import { useToasts } from "react-toast-notifications";
import BasicModal from "../../../components/BasicModal";
import Illustration from "../../../image/Illustration.png";
import { LaoAddress } from "../../../constants/laoAdrees";
import { CREATE_LOGISTIC_ORDER, SUBSCRIBE_LOGISTIC } from "../../../graphql/logistic";
import HorizontalRule from "../../../constants/HorizontalRule";
import { MdKeyboardArrowRight } from "react-icons/md";

function CreateOrderComponent({ setIsCreatedOrder, selectedFbUser, setSelectedFbUser, selectedPage }) {
    const { addToast } = useToasts();
    const { history } = useReactRouter();
    let SHOP_ID = localStorage.getItem("SHOP");

    const [getOrderData, { data: orderData }] = useLazyQuery(
        GET_ORDERGROUPS_DETAIL,
        { fetchPolicy: "cache-and-network" }
    );

    const [getStocks, { data: stockData }] = useLazyQuery(GET_STOCKS, {
        fetchPolicy: "cache-and-network",
    });  
    const [createOrderGroup, { loading: createOrderGroupLoading }] =
        useMutation(CREATE_ORDER_GROUP_FROM_MESSAGE); 
    const [createLogisticOrder, { loading: createLogisticOrderLoading }] =
        useMutation(CREATE_LOGISTIC_ORDER);
    const [subscribeHalLogistic] = useMutation(SUBSCRIBE_LOGISTIC);

    const [showOrder, setShowOrder] = useState(false);
    const [orderList, setOrderList] = useState([]);

    const [cfCode, setCfCode] = useState();
    const [stockId, setStockId] = useState();
    const [productName, setProductName] = useState();
    const [currency, setCurrency] = useState("ກີບ");
    const [amount, setAmount] = useState(1);
    const [price, setPrice] = useState();
    const [totalPrice, setTotalPrice] = useState();
    const [stocksData, setStocksData] = useState([]);
    const [stockAmount, setStockAmount] = useState();
    const [sumPriceLak, setSumPriceLak] = useState();
    const [sumPriceUsd, setSumPriceUsd] = useState();
    const [sumPriceBaht, setSumPriceBaht] = useState();
    const [cfName, setCfName] = useState();
    const [note, setNote] = useState();
    const [phone, setPhone] = useState();
    const [totalAmount, setTotalAmount] = useState();
    const [payment, setPayment] = useState();
    const [paymentType, setPaymentType] = useState("DESTINATION");
    const [check, setCheck] = useState(true);
    const [addressCf, setAddressCf] = useState();
    const [orderGroupStatus, setOrderGroupStatus] = useState(CREATED);
    const [shipPrice, setShipPrice] = useState();
    const [logistic, setLogistic] = useState();
    const [selectedLogistic, setSelectedLogistic] = useState();
    const [editMode, setEditMode] = useState(false);
    const [selectedOrderGroupData, setSelectedOrderGroupData] = useState();
    const [showDeleteStockConfirm, setShowDeleteStockConfirm] = useState(false);
    const [selectedStock, setSelectedStock] = useState({});
    const [selectedOriginalProvice, setSelectedOriginalProvice] = useState();
    const [selectedOriginalDistrict, setSelectedOriginalDistrict] = useState();
    const [selectedDestinationProvice, setSelectedDestinationProvice] =
        useState();
    const [selectedDestinationDistrict, setSelectedDestinationDistrict] =
        useState();
    const [logisticBranches, setLogisticBranches] = useState([]);
    const [originalLogisticBranches, setOriginalLogisticBranches] = useState([]);
    const [destinationLogisticBranches, setDestinationLogisticBranches] =
        useState([]);
    const [selectedOriginalLogisticBranch, setSelectedOriginalLogisticBranch] =
        useState();
    const [
        selectedDestinationLogisticBranch,
        setSelectedDestinationLogisticBranch,
    ] = useState();
    const [selectedIsUsingLogistic, setSelectedIsUsingLogistic] = useState(false);

    useEffect(() => {
        getUserStock();
        setEditMode(history.location.state?.editMode);
        setSelectedOrderGroupData(history.location.state?.orderGroup);
    }, []);

    useEffect(() => {
        if (selectedLogistic && selectedLogistic?.id?.toString() === "0") {
            _fetchLogisticBranches();
            _onSubscribeLogistic();
        }
    }, [selectedLogistic]);

    useEffect(() => {
        if (check) {
            setPaymentType("DESTINATION");
        } else {
            setPaymentType("ORIGINAL");
        }
    }, [check]);

    useEffect(() => {
        if (stockData?.stocks?.data?.length > 0) {
            setStocksData(stockData?.stocks?.data ?? []);
        }
    }, [stockData]);

    useEffect(() => {
        let _total = price * amount;
        setTotalPrice(_total);
    }, [price]);

    useEffect(() => {
        let _total = price * amount;
        setTotalPrice(_total);
    }, [amount]);

    useEffect(() => {
        if (orderList) {
            let _sumPriceLak = 0;
            let _sumPriceBaht = 0;
            let _sumPriceUsd = 0;
            let qty = 0;

            for (let index = 0; index < orderList.length; index++) {
                if (["BAHT", "ບາດ"].includes(orderList[index]?.currency)) {
                    _sumPriceBaht = _sumPriceBaht + orderList[index].totalPrice;
                } else if (["USD", "ໂດລາ"].includes(orderList[index]?.currency)) {
                    _sumPriceUsd = _sumPriceUsd + orderList[index].totalPrice;
                } else {
                    _sumPriceLak = _sumPriceLak + orderList[index].totalPrice;
                }
                qty = parseInt(qty) + parseInt(orderList[index].amount);
            }

            setSumPriceLak(_sumPriceLak);
            setSumPriceBaht(_sumPriceBaht);
            setSumPriceUsd(_sumPriceUsd);
            setTotalAmount(qty);
        }
    }, [orderList]);

    const _fetchLogisticBranches = () => {
        axios
            .get("https://hal.hal-logistics.la/api/v1/listing/branches")
            .then((response) => {
                setLogisticBranches(response.data);
                setOriginalLogisticBranches(response.data);
                setDestinationLogisticBranches(response.data);
            })
            .catch((error) => console.log(error));
    }; 

    const getUserStock = async () => {
        try {
            await getStocks({
                variables: {
                    where: {
                        isDeleted: false,
                        shop: SHOP_ID,
                    },
                    orderBy: "createdAt_DESC",
                    limit: 1000,
                    skip: 0,
                },
            });
        } catch (error) {
            console.log("Error retrieving posts", error);
        }
    };

    const onSelectStock = async (e) => {
        const checkStock = stocksData.filter((stock) =>
            e?.target?.value.trim().split("ລະຫັດ: ")[0] != ""
                ? stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[0]
                : stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[1]
        );

        if (checkStock.length > 0) {
            setCfCode(checkStock[0].cfMessage);
            setCurrency(checkStock[0].currency);
            setProductName(checkStock[0].name);
            setPrice(checkStock[0].price);
            setStockId(checkStock[0].id);
            setStockAmount(checkStock[0].amount);
        }
    };

    const _createOrderList = () => {
        if (!cfCode)
            return addToast("ເລືອກສິນຄ້າໃດຫນຶ່ງກ່ອນ!", {
                appearance: "error",
                autoDismiss: true,
            });

        let _orderList = [...orderList];

        _orderList.push({
            cfMessage: cfCode,
            currency,
            productName,
            amount,
            price,
            totalPrice,
            id: stockId,
            stockId: stockId,
            stockAmount,
        });
        setOrderList(_orderList);
        setShowOrder(false);
    };

    const _saveData = async () => {
        if (
            createOrderGroupLoading ||
            createLogisticOrderLoading
        )
            return;

        if (orderList?.length <= 0)
            return addToast("ເພີ່ມສິນຄ້າໃດຫນຶ່ງກ່ອນ!", {
                appearance: "error",
                autoDismiss: true,
            });

        if (_.isEmpty(phone))
            return addToast("ກະລຸນາປ້ອນເບີໂທລູກຄ້າກ່ອນ!", {
                appearance: "error",
                autoDismiss: true,
            });

        if (_.isEmpty(selectedOriginalLogisticBranch) && selectedIsUsingLogistic)
            return addToast("ກະລຸນາເລືອກສາຂາຂົນຕົ້ນທາງກ່ອນ!", {
                appearance: "error",
                autoDismiss: true,
            });

        if (_.isEmpty(selectedDestinationLogisticBranch) && selectedIsUsingLogistic)
            return addToast("ກະລຸນາເລືອກສາຂາຂົນປາຍທາງກ່ອນ!", {
                appearance: "error",
                autoDismiss: true,
            });

        if (!editMode) await _createOrderGroup();

        if (selectedIsUsingLogistic) _createLogisticOrder();

        addToast("ສ້າງອໍເດີ້ສຳເລັດ!", {
            appearance: "success",
            autoDismiss: true,
        });

        setShowOrder(false);
        setCfCode("");
        setPrice(0);
        setTotalPrice(0);
        setAmount(1);
        setProductName("");

        // history.goBack();
    };

    const _createOrderGroup = async () => {
        try {
            if (createOrderGroupLoading) return;
            const _orderData = orderList?.map((order) => {
                return {
                    type: "KEY_IN",
                    stock: order?.stockId,
                    amount: parseInt(order?.amount) ?? 0,
                    productName: order?.productName ?? "",
                    cfMessage: order?.cfMessage ?? "",
                    price: parseInt(order?.price) ?? 0,
                    currency: order?.currency,
                    phone: phone,
                    totalPrice: parseInt(order?.totalPrice) ?? 0,
                    cfName: cfName,
                    shop: SHOP_ID,
                }
            })
            const _resOrderGroup = await createOrderGroup({
                variables: {
                    data: {
                        type: "KEY_IN",
                        manyOrders: _orderData,
                        amount: parseInt(totalAmount),
                        totalPrice: parseInt(sumPriceLak),
                        sumPriceBaht,
                        sumPriceUsd,
                        customerName: cfName,
                        cfName: cfName,
                        userFbId: selectedFbUser?.senders?.data[0]?.id,
                        pageAccessToken: selectedPage?.access_token,
                        pageId: selectedPage?.id,
                        shop: SHOP_ID,
                        phone: phone,
                        note: '',
                        // payment: payment,
                        paymentType: paymentType,
                        status: orderGroupStatus,
                        shipPrice: parseFloat(
                            shipPrice ? shipPrice.toString().replace(/,/g, "") : 0
                        ),
                        logistic: selectedLogistic?.name ?? logistic,
                        addressCf: addressCf,
                    },
                },
            });
            console.log({ _resOrderGroup })
        } catch (error) {
            console.log("createOrderGroup Error: ", error);
        }
    };

    const handleDelete = () => {
        let _orderList = [...orderList];
        _.remove(_orderList, { id: selectedStock?.id });
        setOrderList(_orderList);
        setShowDeleteStockConfirm(false);
    };

    const _filterOriginalLogisticBranches = (district, isOriginal) => {
        let _newBranches = [];
        _newBranches = logisticBranches.filter(
            (branch) => branch.district.name === district
        );
        isOriginal
            ? setOriginalLogisticBranches(_newBranches)
            : setDestinationLogisticBranches(_newBranches);
    };

    const handleOptionChange = (event) => {
        setSelectedIsUsingLogistic(!selectedIsUsingLogistic);
    };

    const _createLogisticOrder = async () => {
        try {
            const _shopData = JSON.parse(localStorage.getItem(SHOP_DATA));
            const data = {
                data: {
                    sender: {
                        full_name: _shopData?.name,
                        phone_number: _shopData?.phone,
                        zone: "lo",
                    },
                    receiver: {
                        full_name: cfName,
                        phone_number: phone,
                        location: "Local Address",
                    },
                    sender_branch_id: selectedOriginalLogisticBranch?.id,
                    receive_branch_id: selectedDestinationLogisticBranch?.id,
                    description: "From Lailaolab cf-live",
                    shipment_pay_type: "destination_freight_fees",
                    payment_gateway: "BCEL_ONE",
                    shipment_type: "express",
                    parcel_type: "parcel",
                    pieces: 1,
                    store_id: 1,
                    remark: "please be careful for the parcel",
                    parcels: [
                        {
                            name: '',
                            detail: "",
                            category_id: 11,
                            size: '',
                            dimension_length: 58,
                            weight: 2,
                            price: 0,
                            insurance_price: 1,
                            freight: 10000,
                        },
                    ],
                    orderGroup: {
                        logistic: selectedLogistic?.name,
                    },
                },
                where: {
                    id: selectedOrderGroupData?.id,
                },
            };

            await createLogisticOrder({
                variables: data,
            });
        } catch (error) {
            console.log({ error });
        }
    };

    const _onChangeLogistic = (e) => {
        if (e.target.value === "") {
            setLogisticBranches([]);
            setOriginalLogisticBranches([]);
            setDestinationLogisticBranches([]);
            setSelectedLogistic();
            return;
        }
        setSelectedLogistic(LOGISTICS[parseInt(e.target.value)]);
    };

    const _onSubscribeLogistic = async () => {
        await subscribeHalLogistic();
    };

    const onCloseOrderRight = () => {
        setIsCreatedOrder(false)
    }

    return (
        <div style={{ borderLeft: '1px solid #EEE', marginLeft: 10 }}>
            <BasicModal
                show={showDeleteStockConfirm}
                onHide={() => setShowDeleteStockConfirm(false)}
                okay={handleDelete}
                title="ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ຫຼື ບໍ່"
                leftButtonName="ຍົກເລີກ"
                rightButtonName="ຕົກລົງ"
                Illustration={Illustration}
            />
            <div style={{ padding: 20, overflow: 'auto', height: '90vh', }}>
                <div>
                   <div style={{display:'flex',justifyContent:'space-between',paddingBottom:7}}>
                   <h5 style={{ fontWeight: "bold" }}> ສ້າງອໍເດີ້  </h5>
                    <MdKeyboardArrowRight style={{fontSize:24,cursor:'pointer'}} onClick={onCloseOrderRight} />
                   </div>
                    <div style={{ borderBottom: "1px solid #eee", marginBottom: 30 }} />
                    <Row md={12}>
                        <Col md={6}>
                            <h5 style={{ fontWeight: "bold" }}>ຂໍ້ມູນລູກຄ້າ</h5>
                            <br />
                            <Form.Group className="mb-3">
                                <Form.Label
                                    style={{
                                        marginBottom: 2,
                                        fontWeight: "bold",
                                        color: "#5C5C5C",
                                    }}>
                                    ຊື່ລູກຄ້າ
                                </Form.Label>
                                <Form.Control
                                    name="cfName"
                                    type="text"
                                    placeholder="ກະລຸນາປ້ອນຊື່ລູກຄ້າ"
                                    value={cfName}
                                    onChange={(e) => setCfName(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label
                                    style={{
                                        marginBottom: 2,
                                        fontWeight: "bold",
                                        color: "#5C5C5C",
                                    }}>
                                    ເບີໂທ
                                    <span style={{ marginLeft: 1, color: "#FF3939" }}>*</span>
                                </Form.Label>
                                <div style={{ position: "relative" }}>
                                    <span
                                        style={{
                                            position: "absolute",
                                            left: "0",
                                            top: ".41em",
                                            fontSize: 17,
                                        }}>
                                        020
                                    </span>
                                    <Form.Control
                                        style={{
                                            paddingLeft: "3em",
                                        }}
                                        name="phone"
                                        type="text"
                                        placeholder="xxx-xxx-xx"
                                        value={phone}
                                        onChange={(e) => {
                                            const _phone = e?.target?.value;

                                            // Check if the input is a number and has at most 8 digits
                                            if (!/^\d{0,8}$/.test(_phone)) return;

                                            setPhone(_phone);
                                        }}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <h5 style={{ fontWeight: "bold" }}>ຂໍ້ມູນຂົນສົ່ງ</h5>
                            <div style={{ display: "flex" }}>
                                <Form.Check
                                    className="mr-2"
                                    type={"radio"}
                                    label={`ນໍາໃຊ້ຂົນສົ່ງ`}
                                    id={`default-radio`}
                                    checked={selectedIsUsingLogistic}
                                    onChange={handleOptionChange}
                                />
                                <Form.Check
                                    type={"radio"}
                                    label={`ບໍ່ນໍາໃຊ້ຂົນສົ່ງ`}
                                    id={`default-radio`}
                                    checked={!selectedIsUsingLogistic}
                                    onChange={handleOptionChange}
                                />
                            </div>
                            {selectedIsUsingLogistic ? (
                                <div>
                                    <Form.Group className="mb-3">
                                        <Form.Label
                                            style={{
                                                marginBottom: 2,
                                                fontWeight: "bold",
                                                color: "#5C5C5C",
                                            }}>
                                            ເລືອກຂົນສົ່ງ
                                        </Form.Label>
                                        <div
                                            style={{ padding: 0, margin: 0, display: "flex" }}
                                            className="form-control">
                                            {!_.isEmpty(selectedLogistic) && (
                                                <img
                                                    src={selectedLogistic?.icon}
                                                    alt=""
                                                    style={{
                                                        objectFit: "contain",
                                                        marginLeft: 5,
                                                        width: "100%",
                                                        height: "100%",
                                                        maxHeight: "40px",
                                                        maxWidth: "20px",
                                                    }}
                                                />
                                            )}
                                            <Form.Select
                                                name="selectedLogistic"
                                                as="select"
                                                value={selectedLogistic?.id}
                                                onChange={(e) => _onChangeLogistic(e)}
                                                style={{ border: "none" }}>
                                                <option value="">ເລືອກຂົນສົ່ງ</option>
                                                {LOGISTICS.map((logistic, lIndex) => {
                                                    return (
                                                        <option
                                                            value={logistic?.id}
                                                            key={"logistic" + lIndex}>
                                                            {logistic?.name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </div>
                                    </Form.Group>
                                    <div className="row">
                                        <div className="col-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label
                                                    style={{
                                                        marginBottom: 2,
                                                        fontWeight: "bold",
                                                        color: "#5C5C5C",
                                                    }}>
                                                    ສາຂາຕົ້ນທາງ
                                                </Form.Label>
                                                <Form.Select
                                                    name="selectedOriginalProvice"
                                                    as="select"
                                                    value={selectedOriginalProvice?.code}
                                                    onChange={(e) => {
                                                        const _newProvince = _.find(LaoAddress, {
                                                            code: e.target.value,
                                                        });
                                                        setSelectedOriginalProvice(_newProvince);
                                                    }}>
                                                    <option value="">ແຂວງ</option>
                                                    {LaoAddress?.map((province, pIndex) => {
                                                        return (
                                                            <option
                                                                value={province?.code}
                                                                key={"province" + pIndex}>
                                                                {province?.province_name}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Form.Select
                                                    name="selectedOriginalDistrict"
                                                    className="mt-2 mb-2"
                                                    as="select"
                                                    value={selectedOriginalDistrict?.code}
                                                    onChange={(e) => {
                                                        const _newDistrict = _.find(
                                                            selectedOriginalProvice?.district_list,
                                                            { code: e.target.value }
                                                        );
                                                        _filterOriginalLogisticBranches(
                                                            _newDistrict?.district,
                                                            true
                                                        );
                                                        setSelectedOriginalDistrict(_newDistrict);
                                                    }}>
                                                    <option value="">ເມືອງ</option>
                                                    {selectedOriginalProvice?.district_list?.map(
                                                        (district, dIndex) => {
                                                            return (
                                                                <option
                                                                    value={district?.code}
                                                                    key={"district" + dIndex}>
                                                                    {district?.district}
                                                                </option>
                                                            );
                                                        }
                                                    )}
                                                </Form.Select>
                                                <Form.Select
                                                    name="selectedOriginalLogisticBranch"
                                                    as="select"
                                                    value={selectedOriginalLogisticBranch?.id}
                                                    onChange={(e) => {
                                                        const _newDistrict =
                                                            originalLogisticBranches.find(
                                                                (branch) => branch.id == e.target.value
                                                            );
                                                        setSelectedOriginalLogisticBranch(_newDistrict);
                                                    }}>
                                                    <option value="">ສາຂາ</option>
                                                    {originalLogisticBranches?.map((branch, bIndex) => {
                                                        return (
                                                            <option
                                                                value={branch?.id}
                                                                key={"branch" + bIndex}>
                                                                {branch?.name}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                        <div className="col-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label
                                                    style={{
                                                        marginBottom: 2,
                                                        fontWeight: "bold",
                                                        color: "#5C5C5C",
                                                    }}>
                                                    ສາຂາປາຍທາງ
                                                </Form.Label>
                                                <Form.Select
                                                    name="selectedDestinationProvice"
                                                    as="select"
                                                    value={selectedDestinationProvice?.code}
                                                    onChange={(e) => {
                                                        const _newProvince = _.find(LaoAddress, {
                                                            code: e.target.value,
                                                        });
                                                        setSelectedDestinationProvice(_newProvince);
                                                    }}>
                                                    <option value="">ແຂວງ</option>
                                                    {LaoAddress?.map((province, pIndex) => {
                                                        return (
                                                            <option
                                                                value={province?.code}
                                                                key={"province" + pIndex}>
                                                                {province?.province_name}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Form.Select
                                                    name="selectedDestinationDistrict"
                                                    className="mt-2 mb-2"
                                                    as="select"
                                                    value={selectedDestinationDistrict?.code}
                                                    onChange={(e) => {
                                                        const _newDistrict = _.find(
                                                            selectedDestinationProvice?.district_list,
                                                            { code: e.target.value }
                                                        );
                                                        _filterOriginalLogisticBranches(
                                                            _newDistrict?.district,
                                                            false
                                                        );
                                                        setSelectedDestinationDistrict(_newDistrict);
                                                    }}>
                                                    <option value="">ເມືອງ</option>
                                                    {selectedDestinationProvice?.district_list?.map(
                                                        (district, dIndex) => {
                                                            return (
                                                                <option
                                                                    value={district?.code}
                                                                    key={"district" + dIndex}>
                                                                    {district?.district}
                                                                </option>
                                                            );
                                                        }
                                                    )}
                                                </Form.Select>
                                                <Form.Select
                                                    name="selectedDestinationLogisticBranch"
                                                    as="select"
                                                    value={selectedDestinationLogisticBranch?.id}
                                                    onChange={(e) => {
                                                        const _newDistrict =
                                                            destinationLogisticBranches.find(
                                                                (branch) => branch.id == e.target.value
                                                            );
                                                        setSelectedDestinationLogisticBranch(
                                                            _newDistrict
                                                        );
                                                    }}>
                                                    <option value="">ສາຂາ</option>
                                                    {destinationLogisticBranches.map(
                                                        (desBranch, dBIndex) => {
                                                            return (
                                                                <option
                                                                    value={desBranch?.id}
                                                                    key={"desBranch" + dBIndex}>
                                                                    {desBranch?.name}
                                                                </option>
                                                            );
                                                        }
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <Form.Group className="mb-3">
                                        <Form.Label
                                            style={{
                                                marginBottom: 2,
                                                fontWeight: "bold",
                                                color: "#5C5C5C",
                                            }}>
                                            ຂົນສົ່ງ
                                        </Form.Label>
                                        <Form.Control
                                            name="logistic"
                                            type="text"
                                            placeholder="ພິມຂົນສົ່ງ..."
                                            value={logistic}
                                            onChange={(e) => setLogistic(e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label
                                            style={{
                                                marginBottom: 2,
                                                fontWeight: "bold",
                                                color: "#5C5C5C",
                                            }}>
                                            ທີ່ຢູ່ປາຍທາງ
                                        </Form.Label>
                                        <Form.Control
                                            name="addressCf"
                                            type="text"
                                            as="textarea"
                                            placeholder="ສາຂາ, ເມືອງ, ແຂວງ..."
                                            value={
                                                addressCf ||
                                                orderData?.orderGroup?.destinationLogistic
                                            }
                                            onChange={(e) => setAddressCf(e.target.value)}
                                        />
                                    </Form.Group>
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>

                <div style={{ borderBottom: "1px solid #eee",paddingTop:10  }} />


                <div style={{ display: "flex", justifyContent: "space-between",padding:'5px 0' }}>
                <div style={{ fontWeight: "bold",  }}>ລາຍການສິນຄ້າ</div>

                    <Button style={{
                        background: COLOR_APP,
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                    }} onClick={() => setShowOrder(true)}>
                        <FontAwesomeIcon icon={faPlus} className="mr-2" /> ເພີ່ມລາຍການ
                    </Button>
                </div>
                <Table resource>
                    <thead style={{ background: "#F3F4F6" }}>
                        <tr>
                            <th style={{ border: "none" }}>#</th>
                            <th style={{ border: "none" }}>ຮູບ</th>
                            <th style={{ border: "none" }}>ລະຫັດ</th>
                            <th style={{ border: "none" }}>ຊື່</th>
                            <th style={{ border: "none" }}>ຈຳນວນ</th>
                            <th style={{ border: "none" }}>ລາຄາ</th>
                            <th style={{ border: "none" }}>ທັງໝົດ</th>
                            <th style={{ border: "none" }}>ຈັດການ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderList?.map((order, index) => (
                            <tr key={index}>
                                <td style={{ borderBottom: "none" }}>{index + 1}</td>
                                <td style={{ borderBottom: "none" }}>
                                    <img
                                        alt=""
                                        src={imageRender(
                                            order?.liveStock?.image ??
                                            order?.postStock?.image ??
                                            order?.stock?.image
                                        )}
                                        style={{
                                            margin: 0,
                                            padding: 0,
                                            objectFit: "cover",
                                            maxHeight: "40px",
                                        }}
                                    />
                                </td>
                                <td style={{ borderBottom: "none", fontSize:13 }}>{order?.cfMessage || order?.stock?.cfMessage}</td>
                                <td style={{ borderBottom: "none",fontSize:13 }}>{order?.productName}</td>
                                <td style={{ borderBottom: "none",fontSize:13 }}>
                                    {order?.amount}
                                </td>
                                <td style={{ borderBottom: "none",fontSize:13 }}>
                                    {thousandSeperate(order?.price ?? 0)}{" "}
                                    {order?.currency ?? "ກີບ"}
                                </td>
                                <td style={{ borderBottom: "none",fontSize:13 }}>
                                    {thousandSeperate(order?.totalPrice ?? 0)}{" "}
                                    {order?.currency ?? "ກີບ"}
                                </td>
                                <td style={{ borderBottom: "none" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "start",
                                            alignItems: "center",
                                            padding: 6,
                                            color: "red",
                                            fontSize:13
                                        }}
                                        onClick={() => {
                                            setSelectedStock(order);
                                            setShowDeleteStockConfirm(true);
                                        }}>
                                        <FontAwesomeIcon className="mr-2" icon={faTrashCan} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table> 
                
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Form.Group className="mb-3" style={{ width: "46%" }}></Form.Group>
                    <Form.Group className="mb-3" style={{ width: "46%" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                            }}>
                            <div>ຍອດລວມເປັນເງິນ (ກີບ): </div>
                            <div
                                style={{
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    padding: "5px 20px",
                                    borderRadius: 10,
                                    width: "90%",
                                    background: "#F5F5FA",
                                }}>
                                {thousandSeperate(sumPriceLak)}
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                margin: "10px 0px",
                                whiteSpace: "nowrap",
                            }}>
                            <div>ຍອດລວມເປັນເງິນ (ບາດ): </div>
                            <div
                                style={{
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    padding: "5px 20px",
                                    borderRadius: 10,
                                    width: "90%",
                                    background: "#F5F5FA",
                                }}>
                                {thousandSeperate(sumPriceBaht)}
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                            }}>
                            <div>ຍອດລວມເປັນເງິນ (ໂດລາ): </div>
                            <div
                                style={{
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    padding: "5px 20px",
                                    borderRadius: 10,
                                    width: "90%",
                                    background: "#F5F5FA",
                                }}>
                                {thousandSeperate(sumPriceUsd)}
                            </div>
                        </div>
                    </Form.Group>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Form.Group className="mb-3" style={{ width: "46%" }}></Form.Group>
                    <Form.Group
                        className="mb-3"
                        style={{
                            width: "50%",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}>
                        <Button
                            style={{
                                background: "#E8EDF1",
                                color: 'red',
                                border: 'none'
                            }} onClick={onCloseOrderRight}>ຍົກເລີກ</Button>

                        <div style={{ width: "5%" }} />
                        <Button
                            style={{
                                background: COLOR_APP,
                                color: "white",

                            }} onClick={() => _saveData()}
                        >
                            { 
                                createOrderGroupLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                "ບັນທຶກ"
                            )}
                        </Button>
                    </Form.Group>
                </div>
                <div style={{ height: 20 }} />
            </div>
            <Modal show={showOrder} style={{zIndex:99990}}  size="lg">
                <Modal.Header>
                    <Modal.Title>ເພີ່ມລາຍການສັ່ງຊື້</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ textAlign: "center" }}>
                    <div style={{ display: "flex" }}>
                        <Form.Group style={{ width: "50%" }}>
                            <div style={{ textAlign: "start" }}>ລະຫັດ CF</div>
                            <div className="input-group">
                                <input
                                    type="text"
                                    list="listItem"
                                    placeholder="ເລືອກສິນຄ້າ"
                                    onChange={(e) => onSelectStock(e)}
                                    className="form-control form-control-md"
                                />
                                <datalist id="listItem">
                                    {stocksData.length > 0 &&
                                        stocksData?.map((item, index) => {
                                            if (item?.amount <= 0) return "";
                                            return (
                                                <option key={index} value={"ລະຫັດ: " + item?.cfMessage}>
                                                    {"ສິນຄ້າ: " + item?.name}, {"ຈຳນວນ: " + item?.amount},
                                                    {"ລາຄາ: " + item?.price}
                                                </option>
                                            );
                                        })}
                                </datalist>
                            </div>
                        </Form.Group>

                        <div style={{ width: 10 }} />
                        <Form.Group style={{ width: "50%" }}>
                            <div style={{ textAlign: "start" }}>ຊື່ສິນຄ້າ</div>
                            <Form.Control
                                type="text"
                                placeholder=""
                                value={productName}
                                onChange={(e) => setProductName(e.target.value)}
                            />
                        </Form.Group>
                    </div>

                    <div style={{ display: "flex" }}>
                        <Form.Group style={{ width: "50%" }}>
                            <div style={{ textAlign: "start" }}>ຈໍານວນ</div>
                            <NumberFormat
                                name="amount"
                                className="form-control"
                                onChange={(e) => {
                                    if (e.target.value > stockAmount) {
                                        addToast("ປ້ອນຈໍານວນທີ່ນ້ອຍກວ່າ: " + stockAmount, {
                                            appearance: "error",
                                            autoDismiss: true,
                                        });
                                        return;
                                    }
                                    setAmount(e.target.value);
                                }}
                                value={amount ?? 1}
                                placeholder="ຈໍານວນ"
                                thousandSeparator={true}
                                prefix={""}
                            />
                        </Form.Group>
                        <div style={{ width: 10 }} />
                        <Form.Group style={{ width: "50%" }}>
                            <div style={{ textAlign: "start" }}>ລາຄາ</div>
                            <NumberFormat
                                name="price"
                                onChange={(e) => setPrice(e?.target?.value)}
                                value={price}
                                className="form-control"
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                            />
                        </Form.Group>
                    </div>

                    <div style={{ display: "flex" }}>
                        <Form.Group className="mb-3" style={{ width: "50%" }}>
                            <div style={{ textAlign: "start" }}>ທັງໝົດ</div>
                            <NumberFormat
                                name="price"
                                onChange={(e) => setTotalPrice(e?.target?.value)}
                                value={totalPrice}
                                className="form-control"
                                placeholder="0"
                                thousandSeparator={true}
                                prefix={""}
                            />
                        </Form.Group>
                    </div>

                    <div style={{ height: 30 }} />
                    <Button
                        variant="secondary"
                        style={{
                            background: "#E8EDF1",
                            color: "black",
                            borderColor: "#E8EDF1",
                            marginRight: 10,
                        }}
                        onClick={() => {
                            setShowOrder(false);
                            setCfCode("");
                            setPrice(0);
                            setAmount(1);
                            setTotalPrice(0);
                            setProductName("");
                        }}>
                        ຍົກເລີກ
                    </Button>
                    <Button
                        variant="primary"
                        style={{
                            background: COLOR_APP,
                            borderColor: COLOR_APP,
                            marginLeft: 10,
                        }}
                        onClick={() => {
                            _createOrderList();
                        }}>
                        ບັນທຶກ
                    </Button>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default CreateOrderComponent;
